import { render, staticRenderFns } from "./MyBusinessPriceLimit.vue?vue&type=template&id=19f16b50&scoped=true&"
import script from "./MyBusinessPriceLimit.vue?vue&type=script&lang=js&"
export * from "./MyBusinessPriceLimit.vue?vue&type=script&lang=js&"
import style0 from "./MyBusinessPriceLimit.vue?vue&type=style&index=0&id=19f16b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f16b50",
  null
  
)

export default component.exports